class CatalogContentController {
  constructor (VehicleService, ProductService, $state, $stateParams, $q) {
    'ngInject'
    this.catalogType = $state.current.name.split('.')[2]
    this.categoryRef = $stateParams.category.toUpperCase()
    this.isProcessing = true
    this.filter = 'all'
    this.categories = []

    VehicleService.getCurrentSelectedVehicle()
    .then((vehicle) => {
      // Get the current vehicle or the first in list if not set
      if (!vehicle) {
        return Promise.reject()
      }
      return ProductService.getProductCategories()
    })
    .then((categories) => {
      this.categories = categories.filter((category) => {
        // Filter categories regarding the type
        if (this.catalogType === 'maps') {
          return category.ref.match(/^maps/i)
        } else {
          return category.ref.match(/^essentials/i) || category.ref.match(/^tools/i) || category.ref.match(/^news/i) || category.ref.match(/^games/i)
        }
      }).map((category) => {
        return {
          ...category,
          sref: `vehicle.catalog.${this.catalogType}({category: '${category.ref.toLowerCase()}'})`,
          label: `catalog.product.category.${category.ref.toLowerCase()}`,
          weight: this.setCategoryWeight(category.ref)
        }
      })
      this.error = null
      this.isProcessing = false
    }, (err) => {
      this.isProcessing = false
      this.error = err
    })
  }

  get category () {
    return this.categories.find((cat) => cat.ref === this.categoryRef)
  }

  setCategoryWeight (categoryRef) {
    switch (true) {
      case /^essentials/i.test(categoryRef):
        return 1
      case /^tools/i.test(categoryRef):
        return 2
      case /^news/i.test(categoryRef):
        return 3
      case /^games/i.test(categoryRef):
        return 4
      default:
        return 0
    }
  }
}

export default CatalogContentController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/catalog-content/catalog-content.controller.js